/*jshint multistr: true */
angular.module('picmonicng').directive('plsBanners', [
  function () {
    return {
      restrict: 'E',
      scope: {},
      controller: [
        '$scope',
        '$interval',
        'UserService',
        '$cookies',
        'ReferralDataService',
        'GroupBuyService',
        'User',
        'toaster',
        '$timeout',
        'SplitTestService',
        'TwentyFourHourDiscountModal',
        'PermissionsService',
        'ReplaceCardModal',
        'SchoolSourcingModal',
        'GraduationSourcingModal',
        '$q',
        'SalesforceChatService',
        '$http',
        function (
          $scope,
          $interval,
          UserService,
          $cookies,
          ReferralDataService,
          GroupBuyService,
          User,
          toaster,
          $timeout,
          SplitTestService,
          TwentyFourHourDiscountModal,
          PermissionsService,
          ReplaceCardModal,
          SchoolSourcingModal,
          GraduationSourcingModal,
          $q,
          SalesforceChatService,
          $http
        ) {
          $scope.GroupBuyService = GroupBuyService;
          $scope.ReferralDataService = ReferralDataService;
          $scope.UserService = UserService;
          $scope.PermissionsService = PermissionsService;
          $scope.SchoolSourcingModal = SchoolSourcingModal;
          $scope.GraduationSourcingModal = GraduationSourcingModal;
          $scope.now = Math.floor(new Date().getTime() / 1000);

          $scope.copy = function () {
            toaster.success('Copied', 'URL has been copied to the clipboard.');
          };

          $scope.maintenance = {
            banner_start: 1535439600 * 1000,
            banner_end: 1535439600 * 1000,
            period_start: 1535439600 * 1000,
            period_end: 1535439600 * 1000,
            icon: 'build',
            custom_message: 'Picmonic will be offline for scheduled maintenance on 08/29 at 12am MST',
            now: Date.now(),
          };

          GroupBuyService.init();

          var promotion = $http.get('/api/v3/promotions');
          /*
          $scope.promotion = {
            startTime: 1693108800, //1693108800, // 8/27/23 00:00:00 eastern time
            endTime: 1694156400, // 9/8/23 00:00:00 pacific time
            code: 'laborday2023',
            discount: 30,
            icon: '⭐',
            background: '#EE7470',
            message: '<strong>LABOR DAY SALE</strong>',
            cta: 'SAVE&nbsp;30%&nbsp;NOW',
            disclaimer: undefined,
            ctaBackground: '#323A4D',
            color: '#FFF',
            ctaColor: '#FFF',
            hasCountdown: true,
            isActive: function () {
              const now = Date.now() / 1000;
              return this.startTime <= now && this.endTime >= now;
            },
          };
*/
          $q.all([GroupBuyService.group_buy.$promise, promotion])
            .then(function (promises) {
              $scope.promotion = promises[1].data;
              if (
                !$cookies.get('pls_hide_maintenance_banner') &&
                $scope.maintenance.banner_start < $scope.maintenance.now &&
                $scope.maintenance.banner_end > $scope.maintenance.now
              ) {
                $scope.show = 'maintenance';

                $scope.close = function ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                  $scope.show = false;
                  var expires = new Date();
                  expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);
                  $cookies.put('pls_hide_maintenance_banner', 1, {
                    expires: expires,
                  });
                };
              } else if (UserService.user.role === 'Affiliate') {
                $scope.show = '';
              } else if (UserService.user.role === 'Professor' && !UserService.user.institutional_sub) {
                $scope.show = 'educator';
                $scope.onClick = function () {
                  window.open('https://www.picmonic.com/educators', '_blank');
                };
              } else if (
                UserService.user.is_trial &&
                $scope.now > $scope.promotion.start_time &&
                $scope.now < $scope.promotion.end_time &&
                !UserService.user.institutional_sub &&
                (!$scope.promotion.require_referral || UserService.checkForReferral())
              ) {
                $scope.show = 'promotion-banner';

                $scope.now = parseInt(Date.now() / 1000, 10);
                $scope.timeLeft = $scope.promotion.end_time - $scope.now;

                if ($scope.timeLeft > 0) {
                  interval = $interval(function () {
                    $scope.timeLeft--;

                    if ($scope.timeLeft < 0) {
                      $interval.cancel(interval);
                      $scope.show = '';
                    }
                  }, 1000);

                  $scope.$on('$destroy', function () {
                    if (interval) {
                      $interval.cancel(interval);
                    }
                  });
                }

                $scope.hours = function () {
                  var hours = Math.floor($scope.timeLeft / 60 / 60);
                  return hours < 10 ? '0' + hours : hours;
                };

                $scope.minutes = function () {
                  var minutes = Math.floor($scope.timeLeft / 60) % 60;
                  return minutes < 10 ? '0' + minutes : minutes;
                };

                $scope.seconds = function () {
                  var seconds = Math.floor($scope.timeLeft % 60);
                  return seconds < 10 ? '0' + seconds : seconds;
                };
              } else if (
                !UserService.user.is_trial &&
                UserService.user.subscription_recurring === 1 &&
                UserService.user.subscription_payment_method_expiring === 1
              ) {
                $scope.show = 'update_card';

                now = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0, 0);

                month = new Date().getMonth();
                year = new Date().getFullYear();

                if (month === 10) {
                  month = 0;
                  year += 1;
                } else {
                  month += 1;
                }

                then = new Date(year, month, 1, 0, 0, 0, 0, 0);

                $scope.days = Math.floor((then.getTime() - now.getTime()) / 1000 / (60 * 60 * 24));

                $scope.showUpdateCardModal = function () {
                  modal = ReplaceCardModal.show();
                  modal.result.then(function () {
                    UserService.user.subscription_payment_method_expiring = 0;
                    $scope.show = false;
                  });
                };
              } else if (
                (UserService.user.is_trial ||
                  UserService.user.subscription_type === 'Monthly' ||
                  (!UserService.user.is_trial &&
                    UserService.user.premium_expiration &&
                    $scope.now + 60 * 60 * 24 * 30 > UserService.user.premium_expiration)) &&
                // standard access
                (($scope.now >= 1668769140 && $scope.now <= 1669967940) ||
                  // early access for referral users
                  ($scope.now <= 1669967940 && UserService.checkForReferral()) ||
                  // early ad access
                  ($scope.now <= 1669967940 && $cookies.get('black_friday_2022')))
              ) {
                $scope.show = 'black_friday_2021';

                $scope.endTime = 1669967940;
                $scope.time = Math.floor($scope.endTime - Date.now() / 1000);

                if ($scope.time < 60 * 60 * 24) {
                  $scope.timerVisible = true;

                  interval = $interval(function () {
                    $scope.time--;
                  }, 1000);

                  $scope.$on('$destroy', function () {
                    if (interval) {
                      $interval.cancel(interval);
                    }
                  });
                }

                $scope.hours = function () {
                  var hours = Math.floor($scope.time / 60 / 60);
                  return hours < 10 ? '0' + hours : hours;
                };

                $scope.minutes = function () {
                  var minutes = Math.floor($scope.time / 60) % 60;
                  return minutes < 10 ? '0' + minutes : minutes;
                };

                $scope.seconds = function () {
                  var seconds = Math.floor($scope.time % 60);
                  return seconds < 10 ? '0' + seconds : seconds;
                };
              } else if (
                !$cookies.get('pls_hide_referral_banner') &&
                (!$cookies.get('pls_count_referral_banner') || $cookies.get('pls_count_referral_banner') < 25) &&
                (!UserService.user.user_id ||
                  (UserService.user.is_referred && (UserService.user.is_trial || UserService.user.is_fap)))
              ) {
                $scope.show = 'referral';
                if (!$cookies.get('pls_count_referral_banner')) {
                  $cookies.put('pls_count_referral_banner', 1);
                } else {
                  $cookies.put('pls_count_referral_banner', parseInt($cookies.get('pls_count_referral_banner')) + 1);
                }

                $scope.close = function ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                  $scope.show = false;
                  var expires = new Date();
                  expires.setTime(expires.getTime() + 10 * 365 * 24 * 60 * 60 * 1000);
                  $cookies.put('pls_hide_referral_banner', 1, {
                    expires: expires,
                  });
                };
                //} else if (!UserService.checkForReferral() && UserService.user.is_trial && SplitTestService.split('schools_closed_banner_v4', ['a', 'b'], null, true) === 'b') {
                //    $scope.show = 'schools_closed_banner';
              } else if (UserService.shouldShowFPTCta() && !$cookies.get('pls_hide_fpt_banner')) {
                $scope.show = 'fpt';

                $scope.end = UserService.user.created_at + 60 * 60 * 24;
                $scope.now = parseInt(Date.now() / 1000, 10);

                $scope.time = $scope.end - $scope.now;

                if ($scope.time < 60 * 60 * 24) {
                  interval = $interval(function () {
                    $scope.time--;

                    if ($scope.time < 0) {
                      $interval.cancel(interval);
                      $scope.show = '';
                    }
                  }, 1000);

                  $scope.$on('$destroy', function () {
                    if (interval) {
                      $interval.cancel(interval);
                    }
                  });
                }

                $scope.hours = function () {
                  var hours = Math.floor($scope.time / 60 / 60);
                  return hours < 10 ? '0' + hours : hours;
                };

                $scope.minutes = function () {
                  var minutes = Math.floor($scope.time / 60) % 60;
                  return minutes < 10 ? '0' + minutes : minutes;
                };

                $scope.seconds = function () {
                  var seconds = Math.floor($scope.time % 60);
                  return seconds < 10 ? '0' + seconds : seconds;
                };

                $scope.close = function ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                  $scope.show = false;
                  var expires = new Date();
                  expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);
                  $cookies.put('pls_hide_fpt_banner', 1, {
                    expires: expires,
                  });
                };
              } else if (TwentyFourHourDiscountModal.check()) {
                TwentyFourHourDiscountModal.startTimer();
                $scope.hours = function () {
                  return TwentyFourHourDiscountModal.hours;
                };
                $scope.minutes = function () {
                  return TwentyFourHourDiscountModal.minutes;
                };
                $scope.seconds = function () {
                  return TwentyFourHourDiscountModal.seconds;
                };
                $scope.$on('$destroy', function () {
                  TwentyFourHourDiscountModal.endTimer();
                });

                $scope.setCTACookie = function () {
                  TwentyFourHourDiscountModal.setCTACookie();
                };

                $scope.show = 'twenty_four_hour_discount';
              } else if (
                $scope.now > 1607065199 &&
                !$cookies.get('pls_hide_group_buy_banner') &&
                (!$cookies.get('pls_count_group_buy_banner') || $cookies.get('pls_count_group_buy_banner') < 25) &&
                (UserService.user.subscription_type === 'Monthly' || UserService.user.subscription_type === 'Free') &&
                UserService.user.market &&
                !UserService.user.market.is_beta &&
                !UserService.user.role === 'Professor'
              ) {
                $scope.show = 'launch_group_buy';
                if (!$cookies.get('pls_count_group_buy_banner')) {
                  $cookies.put('pls_count_group_buy_banner', 1);
                } else {
                  $cookies.put('pls_count_group_buy_banner', parseInt($cookies.get('pls_count_group_buy_banner')) + 1);
                }

                $scope.close = function ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                  $scope.show = false;
                  var expires = new Date();
                  expires.setTime(expires.getTime() + 14 * 24 * 60 * 60 * 1000);
                  $cookies.put('pls_hide_group_buy_banner', 1, {
                    expires: expires,
                  });
                };
                // LEAD SOURCING RN/LPN/NP
                /*
              } else if (
                !$cookies.get('pls_hide_preso2_banner') &&
                (!$cookies.get('pls_count_preso2_banner') || $cookies.get('pls_count_preso2_banner') < 25) &&
                UserService.user.school.preso_wanted &&
                [101, 202, 203].indexOf(UserService.user.lead) !== -1
              ) {
                $scope.show = 'lead-sourcing-nursing';
                if (!$cookies.get('pls_count_preso2_banner')) {
                  $cookies.put('pls_count_preso2_banner', 1);
                } else {
                  $cookies.put('pls_count_preso2_banner', parseInt($cookies.get('pls_count_preso2_banner')) + 1);
                }

                $scope.close = function ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                  $scope.show = false;
                  var expires = new Date();
                  expires.setTime(expires.getTime() + 14 * 24 * 60 * 60 * 1000);
                  $cookies.put('pls_hide_preso2_banner', 1, {
                    expires: expires,
                  });
                };
                // LEAD SOURCING OTHER
              } else if (
                !$cookies.get('pls_hide_lead_sourcing_non_nursing_banner') &&
                UserService.user.school.preso_wanted &&
                (UserService.user.school.roadtrip_status === 2 || UserService.user.school.roadtrip_status === 3) &&
                [101, 202, 203].indexOf(UserService.user.lead) === -1
              ) {
                $scope.show = 'lead-sourcing-non-nursing';

                $scope.close = function ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                  $scope.show = false;

                  var expires = new Date();
                  expires.setTime(expires.getTime() + 14 * 24 * 60 * 60 * 1000);
                  $cookies.put('pls_hide_lead_sourcing_non_nursing_banner', 1, {
                    expires: expires,
                  });
                };
                */
              } else if (
                !$cookies.get('pls_hide_nclex_workbook_banner') &&
                !UserService.user.is_trial &&
                UserService.user.lead &&
                [101, 202].indexOf(UserService.user.lead) !== -1
              ) {
                $scope.show = 'nclex_workbook_banner';

                $scope.close = function ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                  $scope.show = false;
                  var expires = new Date();
                  expires.setTime(expires.getTime() + 14 * 24 * 60 * 60 * 1000);
                  $cookies.put('pls_hide_nclex_workbook_banner', 1, {
                    expires: expires,
                  });
                };
              } else if (
                !$cookies.get('pls_hide_school_banner') &&
                (!$cookies.get('pls_count_school_banner') || $cookies.get('pls_count_school_banner') < 25) &&
                UserService.user &&
                UserService.user.market &&
                !UserService.user.market.is_beta &&
                UserService.user.cards_viewed >= 6 &&
                (!UserService.user.school.school_id || UserService.user.school.name.indexOf('Other') === 0)
              ) {
                $scope.show = 'school';
                if (!$cookies.get('pls_count_school_banner')) {
                  $cookies.put('pls_count_school_banner', 1);
                } else {
                  $cookies.put('pls_count_school_banner', parseInt($cookies.get('pls_count_school_banner')) + 1);
                }

                $scope.go = function () {
                  SchoolSourcingModal.show();
                };

                $scope.close = function ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                  $scope.show = false;
                  var expires = new Date();
                  expires.setTime(expires.getTime() + 14 * 24 * 60 * 60 * 1000);
                  $cookies.put('pls_hide_school_banner', 1, {
                    expires: expires,
                  });
                };
              } else if (
                !$cookies.get('pls_hide_grad_date_banner') &&
                (!$cookies.get('pls_count_grad_date_banner') || $cookies.get('pls_count_grad_date_banner') < 25) &&
                UserService.user &&
                UserService.user.market &&
                !UserService.user.market.is_beta &&
                UserService.user.cards_viewed >= 4 &&
                UserService.user.school &&
                UserService.user.school.id &&
                (!UserService.user.graduation_month || !UserService.user.graduation_year) &&
                UserService.user.role === 'Student'
              ) {
                $scope.show = 'grad_date';
                if (!$cookies.get('pls_count_grad_date_banner')) {
                  $cookies.put('pls_count_grad_date_banner', 1);
                } else {
                  $cookies.put('pls_count_grad_date_banner', parseInt($cookies.get('pls_count_grad_date_banner')) + 1);
                }

                $scope.go = function () {
                  GraduationSourcingModal.show();
                };

                $scope.close = function ($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                  $scope.show = false;
                  var expires = new Date();
                  expires.setTime(expires.getTime() + 14 * 24 * 60 * 60 * 1000);
                  $cookies.put('pls_hide_grad_date_banner', 1, {
                    expires: expires,
                  });
                };
              } else {
                $cookies.put('pls_count_referral_banner', 0);
                $cookies.put('pls_count_group_buy_banner', 0);
                $cookies.put('pls_count_preso1_banner', 0);
                $cookies.put('pls_count_preso2_banner', 0);
                $cookies.put('pls_count_school_banner', 0);
                $cookies.put('pls_count_grad_date_banner', 0);
                if (UserService.user.is_trial) {
                  $scope.lowPriceText = 'NEW LOWER PRICES - ACT FAST!';
                  // if (
                  //   [100, 101].includes(UserService.user.lead) &&
                  //   SplitTestService.split('price_display_test_23q2', ['a', 'b']) === 'b'
                  // ) {
                  //   $scope.lowPriceText = 'New Lower Prices. ACT FAST - 30% OFF!';
                  // }
                  $scope.show = 'low-price';
                }
              }
            })
            .catch(function (e) {
              console.log(e);
            });
        },
      ],
      template:
        '<div class="pls-banners-main-content" ng-hide="PermissionsService.hasAccess(\'admin\',\'demo_account\').result && !PermissionsService.hasRole(\'superadmin\').result">\
                         <div class="notification-banner pls-white pls-font-16 text-center bg-pls-orange p-t-1 p-b-1 p-l-2" ng-if="show == \'maintenance\'">\
                            <i class="material-icons pull-right pls-peach m-r-2 m-l-2" ng-click="close($event)">close</i>\
                            <i class="material-icons pls-white md-16" style="position: relative;top: 3px;margin-right: 8px;">{{ maintenance.icon }}</i> \
                            <span ng-show="!maintenance.custom_message">Picmonic will be offline for scheduled maintenance on {{maintenance.period_start | date:\'MM/dd @ hh:mm a\':\'-07:00\' }} PST</span>\
                            <span ng-show="maintenance.custom_message">{{ maintenance.custom_message }}</span>\
                         </div>\
                         <a pls-pricing-link ng-click="setCTACookie()" atlas-send="twenty four hour discount bar upgrade to premium access" target="_self" ng-if="show == \'twenty_four_hour_discount\'" class="tif_discount_expiration" atlas-seen="home-banner-24-discount">\
                             <div class="notification-banner pls-white pls-font-16 text-center bg-pls-blue p-t-1 p-b-1 p-l-2">\
                                <i class="material-icons r-t-4" style="color: #FFF900">star</i>\
                                <strong>Save 20%</strong> if you upgrade now!\
                                <strong>{{hours()}}:{{minutes()}}:{{seconds()}}</strong> remaining\
                                <span class="pls-btn pls-btn--white m-l-1 m-t-1 upgrade-button" >UPGRADE</span>\
                                <span class="pls-font-weight-700 underline upgrade-link">UPGRADE</span>\
                            </div>\
                        </a>\
                         <a href="/store" target="_self" ng-if="show == \'tif_discount_expiration\'" class="tif_discount_expiration">\
                             <div class="notification-banner pls-white pls-font-16 text-center bg-pls-blue p-t-1 p-b-1 p-l-2">\
                                <i class="material-icons r-t-4" style="color: #FFF900">start</i>\
                                <strong>Save 20%</strong> if you upgrade now!\
                                <strong>{{hours}}:{{minutes}}:{{seconds}}</strong> remaining\
                                <span class="pls-btn pls-btn--white m-l-1 m-t-1 upgrade-button">UPGRADE</span>\
                                <span class="pls-font-weight-700 underline upgrade-link">UPGRADE</span>\
                            </div>\
                        </a>\
                        <div ng-if="show === \'black_friday_2021\'" class="group-buy-banner bg-pls-black pls-font-20 pls-font-raleway text-center p-t-1 p-b-1" style="display: flex; align-items:center; justify-content:center" pls-pricing-link>\
                            <span class="pls-white">BLACK FRIDAY DOUBLE UP DEAL <span ng-if="timerVisible">{{hours()}}h {{minutes()}}m {{seconds()}}s</span></span></span><br class="visible-xs"/><br class="visible-xs"/><a class="pls-btn pls-btn--meekus pls-black m-l-2 m-r-2 hidden-xs">GET BLACK FRIDAY DEAL <span ng-show="!UserService.user.is_trial">& EXTENDED ACCESS</span></a>\
                        </div>\
                        <div ng-if="show === \'promotion-banner\'" class="notification-banner promotion-banner pls-font-20 pls-font-raleway pls-font-20 text-center clickable" ng-style="{\'background\': promotion.background, \'color\': promotion.message_color}" pls-pricing-link>\
                          <div class="promotion-banner-icon" ng-bind-html="promotion.icon | safeHTML"></div>\
                          <span class="promotion-banner-message"><strong ng-bind-html="promotion.message | safeHTML"></strong> <strong ng-if="promotion.show_countdown && timeLeft < 1*24*60*60">{{hours()}}:{{minutes()}}:{{seconds()}}</strong></span>\
                          <a class="pls-btn pls-btn--white m-l-2 promotion-banner-cta" style="white-space: no-wrap; color: {{promotion.cta_text_color}} !important; background-color: {{promotion.cta_background}} !important;" ng-bind-html="promotion.cta_text | safeHTML"></a>\
                        </div>\
                        <div ng-if="show === \'low-price\'" class="notification-banner promotion-banner pls-font-20 pls-font-raleway pls-font-20 text-center clickable" ng-style="{\'background\': \'#0067A0\'}" pls-pricing-link>\
                          <div class="promotion-banner-icon"><svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">\
                          <path d="M37 17.9714C37 27.8968 28.7173 35.9429 18.5 35.9429C8.28273 35.9429 0 27.8968 0 17.9714C0 8.04608 8.28273 0 18.5 0C28.7173 0 37 8.04608 37 17.9714Z" fill="#0067A0"/>\
                          <path d="M18.5 1.50586C23.2049 1.50586 27.783 2.03335 32.175 3.03062C32.4963 4.7318 32.6641 6.48507 32.6641 8.27653C32.6641 18.6851 26.9987 27.8082 18.5 32.8948C10.0013 27.8082 4.33594 18.6851 4.33594 8.27653C4.33594 6.48514 4.50374 4.7318 4.82496 3.03062C9.21705 2.03335 13.7951 1.50586 18.5 1.50586Z" fill="#FF9100"/>\
                          <path d="M32.175 3.03062C32.4962 4.7318 32.6641 6.48507 32.6641 8.27653C32.6641 16.5399 29.0932 23.9931 23.3688 29.2595C19.2484 25.0621 16.6211 18.7028 16.6211 11.5843C16.6211 7.9675 17.2993 4.54675 18.507 1.50586C23.2094 1.50642 27.7851 2.03384 32.175 3.03062Z" fill="#FFB52D"/>\
                          <path d="M32.8858 2.90286L32.8004 2.45063L32.3394 2.34596C27.8299 1.32194 23.1736 0.802734 18.5 0.802734C13.8264 0.802734 9.17015 1.32194 4.66048 2.34589L4.19957 2.45056L4.11415 2.90279C3.7818 4.66308 3.61328 6.47068 3.61328 8.27541C3.61328 13.4197 4.99305 18.4866 7.60343 22.9284C10.1347 27.2356 13.7717 30.8882 18.121 33.4914L18.5001 33.7182L18.8791 33.4914C23.2285 30.8882 26.8653 27.2356 29.3966 22.9284C32.007 18.4866 33.3867 13.4197 33.3867 8.27541C33.3867 6.47061 33.2182 4.66301 32.8858 2.90286ZM18.5 32.0653C10.0748 26.8525 5.05859 17.9918 5.05859 8.27541C5.05859 6.71007 5.19156 5.14276 5.45418 3.60951C9.71098 2.67857 14.0974 2.20675 18.5 2.20675C22.9026 2.20675 27.2891 2.67857 31.5458 3.60951C31.8084 5.14269 31.9414 6.71 31.9414 8.27541C31.9414 17.9918 26.9252 26.8525 18.5 32.0653Z" fill="#FFCD71"/>\
                          <path d="M9.4668 13.6188C9.4668 8.72906 13.5839 4.77338 18.6343 4.8447C23.513 4.91357 27.4846 8.79076 27.5327 13.5303C27.5581 16.0314 26.5062 18.2941 24.8003 19.9073C24.3871 20.298 23.8091 20.4768 23.2393 20.3908C21.7355 20.1639 20.1451 20.0422 18.5 20.0422C16.864 20.0422 15.2822 20.1625 13.7857 20.387C13.205 20.4742 12.6124 20.2984 12.1919 19.8999C10.5106 18.3063 9.4668 16.081 9.4668 13.6188Z" fill="#FFD993"/>\
                          <path d="M18.4996 17.3789C20.9609 17.3789 23.1922 18.3352 24.8215 19.8861C23.1922 21.437 20.9608 22.3933 18.4996 22.3933C16.0383 22.3933 13.807 21.437 12.1777 19.8861C13.807 18.3352 16.0383 17.3789 18.4996 17.3789Z" fill="#FFCD71"/>\
                          <path d="M10.6563 16.8095H10.1504V9.5293H10.6563V16.8095Z" fill="#004D78"/>\
                          <path d="M11.8222 20.553C11.3633 20.6292 10.8889 20.6691 10.4033 20.6691C9.91776 20.6691 9.44326 20.6292 8.98438 20.553L9.75906 16.9406C9.6928 16.8501 9.65384 16.7394 9.65384 16.6199V16.2358C9.65384 15.9297 9.90923 15.6816 10.2243 15.6816H10.5822C10.8973 15.6816 11.1527 15.9297 11.1527 16.2358V16.6199C11.1527 16.7394 11.1138 16.8501 11.0475 16.9406L11.8222 20.553Z" fill="#0067A0"/>\
                          <path d="M11.2672 16.4214C11.2672 16.885 10.8803 17.2608 10.4031 17.2608C9.9259 17.2608 9.53906 16.885 9.53906 16.4214C9.53906 15.9579 9.92597 15.582 10.4031 15.582C10.8804 15.582 11.2672 15.9578 11.2672 16.4214Z" fill="#1688C7"/>\
                          <path d="M24.027 18.0272C23.975 18.2697 23.7997 18.4698 23.5617 18.5588C22.1853 19.0733 20.6611 19.3592 19.0575 19.3592C17.4538 19.3592 15.9296 19.0733 14.5532 18.5588C14.3152 18.4698 14.1399 18.2697 14.0879 18.0272L12.5 10.623H25.615L24.027 18.0272Z" fill="#0067A0"/>\
                          <path d="M17.6243 19.329C16.3499 19.243 15.1364 18.9761 14.02 18.5588C13.782 18.4698 13.6066 18.2697 13.5547 18.0272L11.9668 10.623H16.5018C16.4516 11.21 16.4259 11.8049 16.4259 12.4067C16.4259 14.8552 16.8515 17.1921 17.6243 19.329Z" fill="#004D78"/>\
                          <path d="M27.9065 9.91224L19.3846 13.3399C18.8338 13.5613 18.2151 13.5613 17.6644 13.3399L9.14242 9.91224C8.92649 9.8254 8.92649 9.52824 9.14242 9.4414L17.6644 6.01377C18.2151 5.79229 18.8339 5.79229 19.3846 6.01377L27.9065 9.4414C28.1225 9.52824 28.1225 9.8254 27.9065 9.91224Z" fill="#1688C7"/>\
                          <path d="M27.9064 9.91224L22.8162 11.9596C18.6686 11.5341 15.6016 10.0214 15.6016 8.2206C15.6016 7.55138 16.0252 6.92189 16.7705 6.37327L17.6643 6.01377C18.215 5.79229 18.8338 5.79229 19.3845 6.01377L27.9064 9.4414C28.1224 9.52824 28.1224 9.8254 27.9064 9.91224Z" fill="#2E9FDE"/>\
                          <path d="M26.5031 8.66965L25.8045 8.98562C25.7831 8.99531 25.7645 9.00991 25.7503 9.02816L25.2851 9.62501C25.2193 9.70939 25.0848 9.69542 25.0388 9.59953L24.7135 8.92083C24.7036 8.90005 24.6885 8.88201 24.6698 8.86818L24.0554 8.41629C23.9685 8.35241 23.9829 8.22177 24.0816 8.17705L24.7802 7.86107C24.8016 7.85139 24.8202 7.83678 24.8344 7.81853L25.2996 7.22168C25.3654 7.1373 25.4999 7.15127 25.5459 7.24717L25.8712 7.92587C25.8811 7.94665 25.8962 7.96469 25.915 7.97852L26.5294 8.4304C26.6162 8.49429 26.6019 8.62493 26.5031 8.66965Z" fill="#FFE7C0"/>\
                          <path d="M25.4562 2.3288L26.7285 1.96677C26.8381 1.9356 26.9399 2.03445 26.9078 2.14101L26.5352 3.37697C26.5273 3.40273 26.5273 3.43011 26.5352 3.45587L26.9078 4.69183C26.9399 4.79833 26.8382 4.89724 26.7285 4.86607L25.4562 4.50404C25.4296 4.49646 25.4014 4.49646 25.3749 4.50404L24.1026 4.86607C23.993 4.89724 23.8912 4.7984 23.9233 4.69183L24.2959 3.45587C24.3037 3.43011 24.3037 3.40273 24.2959 3.37697L23.9233 2.14101C23.8912 2.03452 23.9929 1.9356 24.1026 1.96677L25.3749 2.3288C25.4014 2.33631 25.4296 2.33631 25.4562 2.3288ZM15.907 20.5598L15.4419 21.1567C15.4276 21.1749 15.409 21.1895 15.3877 21.1992L14.689 21.5152C14.5903 21.5598 14.5759 21.6906 14.6628 21.7544L15.2772 22.2063C15.296 22.2201 15.311 22.2383 15.321 22.259L15.6462 22.9377C15.6922 23.0336 15.8268 23.0475 15.8925 22.9632L16.3577 22.3663C16.3719 22.3481 16.3906 22.3335 16.4119 22.3238L17.1106 22.0078C17.2093 21.9631 17.2237 21.8324 17.1368 21.7685L16.5224 21.3167C16.5036 21.3028 16.4886 21.2847 16.4786 21.264L16.1533 20.5853C16.1073 20.4893 15.9728 20.4754 15.907 20.5598Z" fill="white"/>\
                          <path d="M33.1681 24.9228C33.1053 25.7226 32.3812 26.7448 31.2408 27.5216C30.2202 28.2167 29.1229 28.5404 28.3335 28.4464C28.1045 28.7178 27.8653 28.9834 27.616 29.2426C27.0497 29.8316 26.4442 30.3746 25.8048 30.8693C27.1191 30.6521 28.3163 30.8609 28.9302 31.3563C28.536 32.0611 27.4448 32.7061 26.0771 32.9616C24.8292 33.1947 23.6714 33.0439 22.9956 32.6265C22.1601 33.0403 21.2884 33.3855 20.3883 33.6588C20.5881 33.6747 20.789 33.6871 20.9909 33.696C21.1902 33.7048 21.3446 33.8689 21.3356 34.0626C21.3265 34.2562 21.1576 34.4061 20.9583 34.3974C20.1252 34.3608 19.3041 34.267 18.5001 34.1182C17.696 34.2669 16.875 34.3607 16.0419 34.3974C15.8426 34.4061 15.6736 34.2562 15.6646 34.0626C15.6556 33.8689 15.8099 33.7048 16.0092 33.696C16.2111 33.6872 16.412 33.6748 16.6118 33.6588C15.7118 33.3855 14.84 33.0402 14.0045 32.6265C13.3287 33.0439 12.1709 33.1947 10.9231 32.9616C9.5554 32.7061 8.46419 32.0611 8.06998 31.3563C8.68387 30.8609 9.88103 30.6521 11.1953 30.8693C10.5558 30.3746 9.95047 29.8316 9.38413 29.2426C9.13488 28.9834 8.89568 28.7178 8.66667 28.4464C7.87724 28.5404 6.77996 28.2168 5.75936 27.5216C4.61893 26.7449 3.8949 25.7226 3.83203 24.9228C4.57405 24.7221 5.69945 24.9808 6.77295 25.647C5.50397 23.2495 4.89434 20.5707 5.02261 17.8156C5.03164 17.622 5.20053 17.4721 5.39991 17.4808C5.59921 17.4896 5.75357 17.6537 5.74454 17.8474C5.58678 21.2355 6.61845 24.419 8.48753 27.0323C8.37385 26.5971 8.31105 26.1087 8.31322 25.593C8.31893 24.24 8.76972 23.079 9.41 22.5724C10.0459 23.0841 10.4869 24.2486 10.4812 25.6016C10.4761 26.7947 10.1251 27.8384 9.60316 28.4158C10.6592 29.5816 11.8989 30.5959 13.2816 31.4161C12.8936 31.0016 12.538 30.4566 12.2686 29.8242C11.7361 28.574 11.6905 27.334 12.0797 26.6265C12.8697 26.86 13.7394 27.7688 14.2719 29.019C14.7723 30.1938 14.8427 31.3596 14.5265 32.083C15.7653 32.6788 17.0982 33.1266 18.5003 33.4005C19.9024 33.1266 21.2353 32.6788 22.4741 32.083C22.1578 31.3596 22.2283 30.1938 22.7287 29.019C23.2612 27.7688 24.1309 26.86 24.9209 26.6265C25.3101 27.334 25.2645 28.5741 24.732 29.8242C24.4626 30.4566 24.107 31.0016 23.719 31.4161C25.1017 30.5958 26.3414 29.5816 27.3974 28.4158C26.8755 27.8384 26.5244 26.7947 26.5194 25.6016C26.5137 24.2486 26.9546 23.0841 27.5906 22.5724C28.2308 23.079 28.6816 24.24 28.6874 25.593C28.6895 26.1087 28.6268 26.5971 28.5131 27.0323C30.3821 24.419 31.4137 21.2354 31.256 17.8474C31.247 17.6537 31.4014 17.4896 31.6007 17.4808C31.8001 17.4721 31.9689 17.622 31.978 17.8156C32.1062 20.5707 31.4966 23.2495 30.2275 25.647C31.3007 24.9808 32.4261 24.7221 33.1681 24.9228Z" fill="#9BCF1B"/>\
                          <path d="M6.57969 23.4048C6.83182 24.1062 7.13679 24.7854 7.49016 25.438C7.59415 25.63 7.50086 25.8667 7.291 25.9408C7.1172 26.0022 6.92425 25.9284 6.83826 25.7694C6.44116 25.0352 6.10628 24.2742 5.83593 23.4921C5.07938 23.314 4.19023 22.7081 3.46699 21.8044C2.61216 20.7362 2.22952 19.5523 2.41163 18.7699C3.21999 18.791 4.27897 19.4169 5.12534 20.4461C5.01687 19.5863 4.98139 18.7118 5.02171 17.8295C5.03003 17.6468 5.17658 17.4898 5.36462 17.481C5.58054 17.4708 5.75377 17.6426 5.74423 17.8474C5.69068 18.9975 5.77422 20.124 5.98097 21.2126C6.03517 20.9404 6.11191 20.6608 6.21229 20.3793C6.66807 19.1008 7.48106 18.1438 8.25553 17.8655C8.68695 18.5495 8.71666 19.7899 8.26088 21.0684C7.87585 22.1483 7.23593 22.999 6.57969 23.4048ZM28.7388 21.0684C28.283 19.7899 28.3127 18.5494 28.7441 17.8655C29.5186 18.1437 30.3317 19.1008 30.7874 20.3792C30.8877 20.6606 30.9645 20.9403 31.0187 21.2126C31.2254 20.1239 31.309 18.9974 31.2554 17.8473C31.2459 17.6425 31.4191 17.4707 31.635 17.4809C31.8232 17.4897 31.9696 17.6467 31.9779 17.8294C32.0183 18.7117 31.9828 19.5862 31.8743 20.446C32.7207 19.4169 33.7796 18.791 34.588 18.7699C34.7701 19.5522 34.3875 20.7361 33.5327 21.8043C32.8094 22.708 31.9203 23.3139 31.1637 23.4921C30.8933 24.2741 30.5585 25.0351 30.1614 25.7693C30.0754 25.9283 29.8825 26.0021 29.7087 25.9407C29.4988 25.8666 29.4055 25.63 29.5095 25.438C29.8629 24.7854 30.1678 24.1062 30.42 23.4047C29.7637 22.999 29.1238 22.1483 28.7388 21.0684Z" fill="#B9E746"/>\
                          <path d="M6.55322 16.7588C6.5121 17.6426 6.28424 18.4368 5.94662 19.015C5.68393 19.465 5.00167 19.435 4.78191 18.9639C4.49943 18.3584 4.3463 17.5475 4.38749 16.6637C4.45043 15.3121 4.94993 14.17 5.61102 13.6895C6.22477 14.2261 6.61609 15.4072 6.55322 16.7588ZM31.3889 13.6895C32.05 14.17 32.5495 15.3121 32.6124 16.6637C32.6535 17.5474 32.5005 18.3584 32.218 18.9639C31.9982 19.435 31.316 19.465 31.0533 19.015C30.7157 18.4368 30.4879 17.6426 30.4467 16.7588C30.3838 15.4072 30.7751 14.2261 31.3889 13.6895Z" fill="#CAED73"/>\
                        </svg></div>\
                          <span class="pls-abyss promotion-banner-message pls-white pls-font-weight-800"><span>{{lowPriceText}}</span></span>\
                        </div>\
                        <div class="pls-banners-fpt pls-white" ng-if="show == \'fpt\'" pls-pricing-link atlas-send="fpt_banner"><div style="background: linear-gradient(90deg, #96AAE4 0%, #73BEDD 35.42%, #4DD5D6 100%);" class="notification-banner pls-font-16 text-center clickable p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons pull-right m-r-2 m-l-2 r-t-4" ng-click="close($event)">close</i>\
                            <strong>7-Day free Premium trial. </strong> Offer expires in <strong class="pls-deep-sea pls-font-raleway">{{hours()}}:{{minutes()}}:{{seconds()}}</strong> \
                            <span style="display: block;" class="visible-xs m-t-2"/></span>\
                            <a class="pls-btn pls-btn--white pls-blue m-l-1 m-r-1">Try Premium Free</a></span>\
                        </div></div>\
                        <a class="w-100 pls-banners-group-buy-banner" ng-click="GroupBuyService.launch(UserService.user.market.slug);" ng-if="show == \'launch_group_buy\'" atlas-send="launch_group_buy_banner" atlas-seen="home-banner-group-buy"><div style="background: linear-gradient(90deg, #96AAE4 0%, #73BEDD 35.42%, #4DD5D6 100%);" class="notification-banner pls-white pls-font-16 text-center clickable p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons pull-right pls-white m-r-2 m-l-2 r-t-4" ng-click="close($event)">close</i>\
                            <i class="material-icons hidden-xs pls-white r-t-4">attach_money</i> <strong>Save</strong> up to <strong>{{GroupBuyService.defaultValues.discount_after_goal}}%!</strong> &nbsp; <span class="pls-white pls-font-weight-600"><u>Upgrade</u></span>\
                        </div></a>\
                        <a pls-rt-sourcing ng-if="show == \'lead-sourcing-non-nursing\'" atlas-send="seminar_banner">\
                            <div class="notification-banner pls-white pls-font-16 text-center bg-pls-blue p-t-1 p-b-1 p-l-2">\
                              <i class="material-icons pull-right pls-black m-r-2 m-l-2" ng-click="close($event)">close</i>\
                              Get a FREE Memory Seminar and Demo for your school!</span>\
                            </div>\
                        </a>\
                        <a pls-rt-sourcing ng-if="show == \'lead-sourcing-nursing\'" atlas-send="nurse_lead_source_banner"><div class="notification-banner pls-white pls-font-16 text-center bg-pls-blue p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons pull-right pls-black m-r-2 m-l-2" ng-click="close($event)">close</i>\
                            Earn $$$ & get Free Picmonic for your classmates!</span>\
                        </div></a>\
                        <a class="w-100 pls-white" href="https://amzn.to/3l0pnzR" atlas-send="nclex_workbook_banner" target="_blank" ng-if="show == \'nclex_workbook_banner\'"><div style="background-image: linear-gradient(90deg, #96AAE4 0%, #73BEDD 35.42%, #4DD5D6 100%);" class="notification-banner pls-font-16 text-center p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons pull-right m-r-2 m-l-2 r-t-4 m-b-1" ng-click="close($event)">close</i>\
                            <div class="m-r-1 m-l-1"><div class="visible-xs clearfix"></div><i style="color: #333A4D;" class="material-icons pls-white r-t-4">menu_book</i> <strong>Have you seen our 4 Weeks to NCLEX Workbook & Study Planner?</strong><div class="visible-xs m-t-1"></div><span class="pls-btn pls-btn--white pls-blue m-l-1" >Check it Out</span></div>\
                        </div></a>\
                        <a pls-pricing-link ng-if="ReferralDataService.referral.sender && show == \'referral\' && !ReferralDataService.referral.affiliate" atlas-send="referral_banner" atlas-seen="home-banner-referral"><div class="notification-banner pls-white pls-font-16 text-center bg-pls-magnum p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons pull-right pls-wet-cement m-r-2 m-l-2" ng-click="close($event)">close</i>\
                            <i class="material-icons hidden-xs pls-white r-t-4">favorite</i> {{ReferralDataService.referral.sender}} just got you <span class="pls-orange pls-font-weight-600">20% off</span> Picmonic! <span class="pls-blue pls-font-weight-600"><u>Learn more now</u></span>\
                        </div></a>\
                        <a pls-pricing-link ng-if="ReferralDataService.referral.sender && show == \'referral\' && ReferralDataService.referral.affiliate" atlas-send="affiliate_referral_banner" atlas-seen="home-banner-affiliate"><div class="notification-banner pls-white pls-font-16 text-center bg-pls-magnum p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons pull-right pls-wet-cement m-r-2 m-l-2" ng-click="close($event)">close</i>\
                            <strong><i class="material-icons valign-middle pls-orange" ng-show="ReferralDataService.referral.affiliate.affiliate_type === \'User\'">check_circle</i><img ng-if="ReferralDataService.referral.affiliate.avatar_img_url" ng-src="{{ReferralDataService.referral.affiliate.avatar_img_url}}" ng-show="ReferralDataService.referral.affiliate.affiliate_type === \'Company\'" class="p-r-2" /> {{ ReferralDataService.referral.affiliate.user_discount_percent | integer }}% <span ng-show="ReferralDataService.referral.affiliate.affiliate_type === \'Company\'">{{ReferralDataService.referral.affiliate.name}} Member</span> Discount!</strong> <em class="pls-white">Applied at checkout</em>. <u class="pls-blue">Learn more now</u></span>\
                        </div></a>\
                        <a ng-click="go($event)" ng-if="show == \'grad_date\' && (!UserService.user.graduation_year || !UserService.user.graduation_month)" atlas-send="grad_date_banner"><div class="notification-banner pls-white pls-font-16 text-center bg-pls-blue p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons pull-right pls-jullians-eyes m-r-2 m-l-2" ng-click="close($event)">close</i>\
                            <i class="material-icons hidden-xs pls-black r-t-4">event available</i> <span class="pls-black pls-font-weight-600"><u><i>Update my graduation date</i></u></span> for better Picmonic recommendations\
                        </div></a>\
                        <a ng-click="go($event)" ng-if="show == \'school\'" atlas-send="school_banner"><div class="notification-banner pls-white pls-font-16 text-center bg-pls-blue p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons pull-right pls-jullians-eyes m-r-2 m-l-2" ng-click="close($event)">close</i>\
                            <i class="material-icons hidden-xs pls-black r-t-4">person</i> <span class="pls-black pls-font-weight-600"><u><i>Update my school</i></u></span> for better Picmonic recommendations\
                        </div></a>\
                        <a ng-click="showUpdateCardModal();" ng-if="show == \'update_card\'" atlas-send="update_credit_card_banner"><div class="notification-banner pls-white pls-font-16 text-center bg-pls-mugatu p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons hidden-xs pls-white r-t-4">alarm</i> <strong>Your credit card will expire in {{days}} days.</strong>&nbsp;<br class="visible-xs"/><span class="pls-black pls-font-weight-600"><u>Update billing info</u></span>\
                        </div></a>\
                        <div ng-if="show == \'educator\'" atlas-send="educator_banner" ng-click="onClick()"><div class="pointer notification-banner pls-white pls-font-16 text-center bg-pls-blue p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons hidden-xs pls-black m-r-1" style="vertical-align:text-bottom">person_add</i><i class="pls-black">Bring Picmonic to your program! Learn more about using Picmonic as a teaching tool <u>HERE</u></i> \
                        </div></div>\
                        <div ng-if="show == \'schools_closed_banner\'" style="min-height: 64px;cursor: pointer;" class="flex-box flex-container--center pls-font-20 bg-pls-abyss referral-header text-center pls-white flex--vertical p-a-1" pls-pricing-link="UserService.user.lead">\
                          <div>\
                            <div>\
                              <i class="material-icons valign-middle">favorite</i> <span class="pls-orange">Save 20%</span> while schools are closed</span>\
                            </div>\
                          </div>\
                        </div>\
                        </div>\
                        ',
    };
  },
]);

// Functions, conditions & templates for "First user at school" and "First purchase at school" BANNERS

//Functions

//  $scope.firstTrialistMessage = function ($event) {
//       SalesforceChatService.startChat(
//         'Hello! I am officially the FIRST student from ' +
//           UserService.user.school.name +
//           ' to check out Picmonic Free! Hook me up with some free Premium access, please!'
//       );
//       UserService.see('first_trialist_banner');
//     };
//     $scope.firstPurchaseMessage = function () {
//       SalesforceChatService.startChat(
//         'Hello! I am officially the FIRST student from ' +
//           UserService.user.school.name +
//           ' to get Picmonic Premium - which means I’m a VIP! What do I get for being the amazing trailblazing maverick of awesomeness that I am?'
//       );
//       UserService.see('first_purchase_banner');
//     };

//Conditions 1

// if ($cookies.get('pls_hide_first_trialist_banner')) {
//   UserService.see('first_trialist_banner');
// }

// if ($cookies.get('pls_hide_first_purchase_banner')) {
//   UserService.see('first_purchase_banner');
// }

//Conditions 2

// else if (
//   UserService.user.is_trial &&
//   !UserService.user.has_seen.first_trialist_banner &&
//   !UserService.user.premium_trial_eligible &&
//   !UserService.user.misc.school_first_purchase &&
//   UserService.user.misc.school_first_trial
// ) {
//   $scope.show = 'first_trialist';

//   $scope.close = function ($event) {
//     $event.preventDefault();
//     $event.stopPropagation();
//     $scope.show = false;
//     UserService.see('first_trialist_banner');
//   };
// }

// else if (
//   !UserService.user.has_seen.first_purchase_banner &&
//   UserService.user.misc.school_first_purchase
// ) {
//   $scope.show = 'first_purchase';

//   $scope.close = function ($event) {
//     $event.preventDefault();
//     $event.stopPropagation();
//     $scope.show = false;
//     UserService.see('first_purchase_banner');
//   };
// }

//Templates

{
  /* <a ng-click="firstTrialistMessage();" ng-if="show == \'first_trialist\'" atlas-send="first_trialist_banner"><div class="notification-banner pls-white pls-font-16 text-center bg-pls-orange p-t-1 p-b-1 p-l-2">\
<i class="material-icons pull-right pls-peach m-r-2 m-l-2 r-t-4" ng-click="close($event)">close</i>\
<i class="material-icons hidden-xs pls-white r-t-4">card_giftcard</i> <strong>You are the 1st!</strong> &nbsp; <span class="pls-black pls-font-weight-600"><u>Request Free Time</u></span>\
</div></a>\

<a ng-click="firstPurchaseMessage();" ng-if="show == \'first_purchase\'" atlas-send="first_purchase_banner"><div class="notification-banner pls-white pls-font-16 text-center bg-pls-orange p-t-1 p-b-1 p-l-2">\
<i class="material-icons pull-right pls-peach m-r-2 m-l-2 r-t-4" ng-click="close($event)">close</i>\
<i class="material-icons hidden-xs pls-white r-t-4">flag</i> <strong>You</strong> are the <strong>first!</strong> &nbsp; <span class="pls-black pls-font-weight-600"><u>Request VIP Treatment</u></span>\
</div></a>\ */
}
